module.exports = __webpack_public_path__ + "static/media/waitListSuccessScreen.fb39e820.png";